(function () {
    /**
     * Used for small init functions.
     */

    /**
     * Example plain js foreach function
     */
    const initSandwiches = () => {
        var sandwiches = document.querySelectorAll('h1');

        if (sandwiches.length) {
            sandwiches.forEach(function (sandwich, index) {
                console.log(sandwich.textContent + ' ' + index); // The element
            });
        } else {
            alert('Where is your H1?');
        }
    };

    const smoothScrollAnchors = () => {
        const anchorLinks = document.querySelectorAll(
            '.smooth-scroll-anchors a'
        );

        if (!anchorLinks) {
            return;
        } else {
            function smoothScroll(target) {
                document.querySelector(target).scrollIntoView({
                    behavior: 'smooth',
                });
            }

            for (let link of anchorLinks) {
                link.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    smoothScroll(ev.target.hash);
                });
            }
        }
    };

    /**
     * Scroll to top
     */
    const scrollButton = document.querySelector('#footer-backtotop');
    if (scrollButton != undefined) {
        scrollButton.addEventListener('click', (event) => {
            event.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }

    /**
     * Toggle Search
     */
    const toggleSearch = () => {
        const searchToggleLink = document.getElementById('search-toggle'),
            searchInput = document.querySelector('.search-form__input'),
            searchFormEl = document.querySelector('.search-form'),
            searchSubmit = document.querySelector('.search-form__submit');

        searchToggleLink.addEventListener('click', function (event) {
            searchFormEl.classList.toggle('toggled');

            if (searchFormEl.classList.contains('toggled')) {
                searchInput.focus();
                searchInput.value = '';
            }
        });
    };

    /**
     * Clear Search
     */
    const clearSearch = () => {
        const searchClearLink = document.getElementById('clear-search'),
            searchInput = document.querySelector('.search-form__input'),
            searchFormEl = document.querySelector('.search-form'),
            searchSubmit = document.querySelector('.search-form__submit');

        searchClearLink.addEventListener('click', function (event) {
            searchFormEl.classList.remove('toggled');
        });
    };

    /**
     * AlertClose
     */
    const alertClose = () => {
        const alertButton = document.getElementById('close-alert'),
            alertBar = document.getElementById('alert-bar');

        alertButton.addEventListener('click', function (event) {
            alertBar.style.display = 'none';
            Cookies.set('alert', 'newvisitor', { expires: 7 });
        });

        if (Cookies.get('alert')) {
            alertBar.style.display = 'none';
        }
    };


    document.addEventListener('DOMContentLoaded', () => {
        //initSandwiches();
        /**
         * Init lazyload - used for lazyloading images and iframes that have class "lazy".
         * Plugin is enqueued in functions.php (commented out)
         * more examples: https://github.com/verlok/vanilla-lazyload#-getting-started---html
         */
        //var lazyLoadInstance = new LazyLoad();

        toggleSearch();
        clearSearch();
        alertClose();

        smoothScrollAnchors();
    });
})();